import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { USER_DATA } from '../types/user.js';
import { AUDIT_OPERATION, AuditOpValues, AuditSourceValues, } from '../types/audit.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/** JSON snapshot / value payload — generous; not shown in forms. */
const AUDIT_JSON_MAX = 100000;
/**
 * Append-only field-audit operation header (spec 0046 / request 0249).
 * Actor (`userId` / `at`) is stamped by system-api — never trust the client.
 */
export const auditOperationDescriptor = {
    name: AUDIT_OPERATION,
    label: 'Operação de auditoria',
    domain: 'audit',
    collectionPath: 'org/{orgId}/audit-operation',
    pathPatternKeys: { orgId: 'string' },
    version: 1,
    description: 'Append-only log of one record change within a save',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    writePolicy: 'append-only',
    indexes: [
        { fields: ['at'] },
        { fields: ['aggregateEntity', 'at'] },
        { fields: ['entity', 'at'] },
    ],
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        {
            name: 'groupId',
            label: 'Grupo',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_LOCAL_ID,
        },
        {
            name: 'entity',
            label: 'Entidade',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_ENTITY_NAME,
        },
        {
            name: 'recordId',
            label: 'Registro',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_LOCAL_ID,
        },
        {
            name: 'aggregateEntity',
            label: 'Agregado (entidade)',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_ENTITY_NAME,
        },
        {
            name: 'aggregateId',
            label: 'Agregado',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_LOCAL_ID,
        },
        {
            name: 'aggregateLabel',
            label: 'Rótulo do agregado',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.DESCRIPTION,
        },
        {
            name: 'aggregateVersion',
            label: 'Versão do agregado',
            type: 'number',
            required: false,
        },
        {
            name: 'op',
            label: 'Operação',
            type: 'enum',
            required: true,
            enumValues: [...AuditOpValues],
        },
        {
            name: 'source',
            label: 'Origem',
            type: 'enum',
            required: true,
            enumValues: [...AuditSourceValues],
        },
        {
            name: 'reason',
            label: 'Motivo',
            type: 'string',
            required: false,
            maxLength: FIELD_LIMITS.DESCRIPTION,
        },
        {
            name: 'userId',
            label: 'Usuário',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.EXTERNAL_LOCAL_ID,
        },
        { name: 'at', label: 'Quando', type: 'date', required: true },
        {
            name: 'changedCount',
            label: 'Campos alterados',
            type: 'number',
            required: true,
        },
        {
            name: 'snapshotJson',
            label: 'Snapshot',
            type: 'string',
            required: false,
            maxLength: AUDIT_JSON_MAX,
            description: 'Filtered document as JSON string — delete: state before; child create/update: state after (not type object — PG jsonb trap)',
        },
    ],
    foreignKeys: [
        {
            fieldName: 'userId',
            targetEntity: USER_DATA,
            relationship: 'many-to-one',
            displayField: 'name',
            expand: false,
        },
    ],
};
//# sourceMappingURL=audit-operation.descriptor.js.map